import { COMPANY_ID } from "app/utils/constant";
import axiosInstance from "./axiosInstance";

// member details
export const memberDetailsApi = async (id) => {
  try {
    const res = await axiosInstance.get(`/users/${id}`, {
      headers: {
        'x-user-id': id,
        'x-organisation-id': COMPANY_ID,
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
    });
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch details of member!");
    }
  } catch (error) {
    console.error("error", error);
    return error.response;
  }
};

// non-tabler member by id
export const nonTablerDetails = async (id) => {
  try {
    const res = await axiosInstance.get(`/members/${id}`);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch details of member!");
    }
  } catch (error) {
    console.error("error", error);
    return error.response;
  }
};

// list non-tablers
export const listNonTablers = async (payload) => {
  const { name, phone_number } = payload;

  try {
    const res = await axiosInstance.get(
      `/members?page=1&limit=10&name=${name}&phone_number=${phone_number}`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

export const listMembers = async (
  page,
  limit,
  sort,
  order,
  search,
  orgId,
  areaId,
  tableId
) => {
  try {
    let url = `/users?page=${page}&limit=${limit}&sort=${sort}&order=${order}&first_name=${search}&member_type=${search}&organisation_id=${orgId}`;

    if (areaId) {
      url += `&area_id=${areaId}`;
    }

    if (tableId) {
      url += `&company_division_id=${tableId}`;
    }

    const res = await axiosInstance.get(url);

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

export const listMembersByCompanyDivision = async (
  page,
  limit,
  sort,
  order,
  search,
  id
) => {
  try {
    const res = await axiosInstance.get(
      `/users?page=${page}&limit=${limit}&sort=${sort}&order=${order}&first_name=${search}&member_type=${search}&company_division_id=${id}`
    );
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

export const listMembersByOrgId = async (page, limit, sort, order, search) => {
  try {
    const res = await axiosInstance.get(
      `/users?page=${page}&limit=${limit}&sort=${sort}&order=${order}&first_name=${search}&organisation_id=${COMPANY_ID}`
    );
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

export const listMembersByEventId = async (payload) => {
  const { limit, page, eventId, searchQuery, filter } = payload;

  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/members?payment_status=${filter}&limit=${limit}&page=${page}&name=${searchQuery}`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

export const listRegisteredMembers = async (payload) => {
  const { limit, page, eventId, searchQuery, filter } = payload;

  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/transactions?limit=${limit}&page=${page}&user_name=${searchQuery}&paid_status=${filter}`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

export const toGetPaymentDetails = async (payload) => {
  const eventId = payload.eventId;
  const userId = payload.userId;

  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/transactions?limit=50&user_id=${userId}`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch payment details!");
    }
  } catch (error) {
    console.error("Error fetching payment details:", error);
    return error.response;
  }
};

export const deleteMember = async (id) => {
  try {
    const res = await axiosInstance.delete(`/users/${id}`);
    if (res.status === 200 || res.status === 201) {
      return res?.data?.message || "Member deleted successfully";
    } else {
      console.error("Failed to delete member!");
    }
  } catch (error) {
    console.error("Error deleting member:", error);
    return error.response;
  }
};

export const memberUpdateApi = async (id, data) => {
  try {
    const res = await axiosInstance.patch(`/users/${id}`, data);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to update member profile!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

export const nonTablerUpdate = async (id, data) => {
  try {
    const res = await axiosInstance.patch(`/members/${id}`, data);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to update member profile!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

export const memberAddApi = async (data) => {
  try {
    const res = await axiosInstance.post(`/admin/users`, data);
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch events!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

// add square leg members by convenor
export const addSquareLegMembers = async (payload) => {
  try {
    const res = await axiosInstance.post(`/users/create`, payload);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to add user!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

// room allocation to members by hotel user
export const allocateRooms = async (payload) => {
  const { event_id, user_id, data, } = payload;

  try {
    const res = await axiosInstance.post(`/events/${event_id}/users/${user_id}/hotel-rooms`, data);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to allocate room!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

export const memberPhotoUpload = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", "profiles");

    const res = await axiosInstance.post(`/file-upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to upload photo!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

// list members by company
export const listMembersByCompany = async (payload) => {
  const company_division_id = payload.location;
  const search = payload.searchMember;

  try {
    const res = await axiosInstance.get(
      `/companies/${COMPANY_ID}/members?company_division_id=${company_division_id}&name=${search}`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

// register an event check

export const checkRegistrationStatus = async (payload) => {
  const eventId = payload?.eventId;
  const userId = payload?.userId;

  try {
    const res = await axiosInstance.head(
      `/events/${eventId}/users/${userId}/is-registration-allowed`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      return res;
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

export const listCompanyDivisions = async (all = false) => {
  try {
    const queryParam = all ? "?all=true" : "";

    const res = await axiosInstance.get(
      `/companies/${COMPANY_ID}/locations${queryParam}`
    );

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch company divisions!");
    }
  } catch (error) {
    console.error("Error fetching company divisions:", error);
    return error.response;
  }
};

export const listMembersFilter = async (payload) => {
  try {
    const res = await axiosInstance.get(
      `/users?page=${payload.page}&limit=${payload.limit}&first_name=${payload.first_name}&member_type=${payload.member_type}&organisation_id=${COMPANY_ID}&status=${payload.status}`
    );
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

// list members by area(s)
export const listMembersByArea = async (areaIds, page = 1, limit = 10, sort = "created_at", order = "desc", search = "", orgId = COMPANY_ID) => {
  try {
    const areaIdParam = Array.isArray(areaIds) ? areaIds.join(',') : areaIds;

    const res = await axiosInstance.get(
      `/users?page=${page}&limit=${limit}&sort=${sort}&order=${order}&first_name=${search}&member_type=${search}&organisation_id=${orgId}&area_id=${areaIdParam}`
    );

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch members by area!");
      return null;
    }
  } catch (error) {
    console.error("Error fetching members by area:", error);
    return error.response;
  }
};

//member to organizer
export const makeOrganizer = async (payload) => {
  try {
    const res = await axiosInstance.patch(
      `/events/${payload.eventId}/make-organiser`,
      payload.data
    );
    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

// products purchased by a member during registration
export const purchaseDetails = async (payload) => {
  const eventId = payload?.eventId;
  const userId = payload?.userId;

  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/users/${userId}/purchased-products`
    );
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch purchase details!");
    }
  } catch (error) {
    console.error("Error fetching purchase details:", error);
    return error.response;
  }
};

export const unregisteredMembersList = async (payload) => {
  const { limit, page, eventId, search, area_id, company_division_id } = payload;

  try {
    let url = `/events/${eventId}/users/unregistered?limit=${limit}&page=${page}&name=${search}`;

    // Add area filter if provided
    if (area_id) {
      url += `&area_id=${area_id}`;
    }

    // Add table filter if provided
    if (company_division_id) {
      url += `&company_division_id=${company_division_id}`;
    }

    const res = await axiosInstance.get(url);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch members!");
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    return error.response;
  }
};

// phone number change request list
export const requestsListToChangePhoneNo = async (page, limit, search, statusFilter, sort, order,) => {
  try {
    const res = await axiosInstance.get(`/phone-change-requests?page=${page}&limit=${limit}&name=${search}&status=${statusFilter}&sort=${sort}&order=${order}`);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch requests list!");
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// user details of requested person
export const requestedUserDetails = async (payload) => {
  const { userId, requestId } = payload;
  try {
    const res = await axiosInstance.get(`/phone-change-requests?request_id=${requestId}&user_id=${userId}`);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to fetch user data!");
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};

// change phone number request approval
export const changePhoneNumberRequestApproval = async (payload) => {
  const { userId, requestId, action } = payload;
  try {
    const res = await axiosInstance.post(`/users/${userId}/review-phone-change-request/${requestId}?action=${action}`);
    if (res.status === 200 || res.status === 201) {
      return res;
    } else {
      console.error("Failed to perform the action!");
    }
  } catch (error) {
    if (error.response) {
      console.error("API Error Response:", error.response);
      return error.response;
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Error:", error.message);
    }
  }
};

export const submitPhoneChangeRequest = async (userId, phoneNumber) => {
  try {
    const res = await axiosInstance.post(`/users/${userId}/request-phone-change`, {
      phone_number: phoneNumber,
    });
    if (res.status === 200 || res.status === 201) {
      return res.data;
    } else {
      console.error("Failed to submit phone change request!");
      return null;
    }
  } catch (error) {
    console.error("Error submitting phone change request:", error);
    return null;
  }
};

//get shared room users
export const getSharedRoomUsers = async (
  eventId,
  { productName, variationName } = {}
) => {
  try {
    const res = await axiosInstance.get(
      `/events/${eventId}/shared-room-users`,
      {
        params: {
          ...(productName && { product_name: productName }),
          ...(variationName && { variation_name: variationName }),
        },
      }
    );

    if (res.status === 200 || res.status === 201) {
      return res?.data;
    } else {
      console.error("Failed to fetch shared room users!");
    }
  } catch (error) {
    console.error("error", error);
    return error?.response;
  }
};